<template>
    <div class="box product">
         <div class="top row mx-auto p-3">
          <h2>{{product.name}}</h2><div id="close"><font-awesome-icon @click="$root.$emit('hidePopup')" icon="times" style="font-size: 24px;vertical-align:middle" /></div>
        </div>
        <img v-for="i in product.images" width="100%" :key="i.id" :src="'/api/Image/Get/' + i.id" id="mv_product_img">
        <p class="my-3" v-if="product.description" v-html="product.description"></p>
        <template v-if="product.availableVariants.length > 0">
        <br><br>
        <b class="text-muted text-uppercase">Varianti</b>
        <div class="variant-picker my-4">
            <div v-for="v in product.availableVariants" :key="v.id" class="variant" :class="{'active': variant && v.id === variant.id}" @click="variant = v;">
                <div class="variant-name"><b-icon-check-circle-fill variant="primary" v-if="variant && v.id === variant.id" /><b-icon-circle  v-else /> {{v.name}}</div>
                <div class="variant-price">{{utils.euro(v.price)}}</div>
            </div>
        </div>
        </template>
        <component :is="components[product.class]" :product="product" :quantity="quantity" ref="component" :popup="true"></component>
        <div class="fixed" v-if="this.$store.getters.enableCheckout">
            <QtySelector v-model="quantity"/>
            <button class="btn btn-primary btn-lg w-100 mt-2" @click="add">Aggiungi al tuo ordine</button>
        </div>
    </div>
</template>

<script>
import SimpleProduct from './SimpleProduct'
import ComposableProduct from './ComposableProduct'
import QtySelector from './QtySelector'
import utils from '@/utils'
export default {
    props: ['product'],
    components: {
        QtySelector
    },
    data(){
        return {
            quantity: 1,
            components: {
                'simple': SimpleProduct,
                'composable': ComposableProduct
            },
            utils,
            variant: this.product.variant
        }
    },
    methods: {
        add(){
            let item = this.$refs.component.addToCart();
            if(item !== null){
                let input = {fields: item,quantity: this.quantity,idProduct:this.product.id};
                if(this.variant)input.fields.idVariant = this.variant.id;
                this.$store.dispatch('addToCart',input);
                this.$root.$emit('hidePopup')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/styles/variables.scss";
    .box.product {
        box-sizing:border-box;padding: 1em;
        
        .top {
            border-bottom: 1px solid #DDD;
            display: flex;
            align-items: center;
            justify-content: space-between;
            #close {
            cursor: pointer;
            }
        }
        @media screen and (max-width: 768px) {
            padding-bottom: calc(2em + env(safe-area-inset-bottom));
        }
    }

    #mv_product_img {
        width:100%;
        height: 300px;
        object-fit: cover;
    }

    .variant-picker {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .variant {
        padding: .5em;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        border-bottom: 1px solid #DDD;

        cursor: pointer;
        &.active {
            font-weight: 600;
        }
    }

    .variant-name {
        font-size: 1rem;
    }

    .variant-price {
        font-size: 0.85rem;
    }
@media screen and (max-width: 768px) {

    .fixed {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    width: 100vw;
    margin-left: -1em;
    box-sizing: border-box;
    padding: 1em;
    background-color: rgba(255, 255, 255, 0.9);
    display: flex;
    flex-direction: column;
    justify-content: center;
}
}
</style>
